import theme from '@css/theme';
import Button from '@ui-library/button';
import { Flex } from '@ui-library/misc';
import { SelectV1 } from '@ui-library/select';
import { Body, Subtext, TableBody } from '@ui-library/typography';
import styled from 'styled-components';

export const Header = styled.div`
  margin-bottom: 32px;
`;

export const ButtonView = styled.div`
  display: flex;
  flex-direction: row;
`;

export const DropdownContainer = styled(SelectV1)`
  min-width: 167px;
  display: flex;
  align-items: center;
  margin-left: 16px;

  .ant-select-selector {
    background: ${theme.color.background2} !important;
  }
`;

export const ProfileContainer = styled(Flex)`
  background: ${theme.color.background1};
  height: 100%;
`;

const headerHeight = '155px';

export const TabsContainer = styled(Flex)<{ enableNewSettings: boolean }>`
  .ant-tabs-nav {
    margin: 0 !important;
    padding-left: 48px !important;
    background: ${theme.color.background1};
  }

  .ant-tabs-tabpane {
    padding: 48px;
    background: ${({ enableNewSettings }) => (enableNewSettings ? 'white' : '#FAFAFA')};
    min-height: calc(100vh - ${headerHeight});
  }

  .ant-tabs {
    width: 100% !important;
  }
`;

export const EditContainer = styled(Flex)`
  border: 1px solid ${theme.text.color.disabled};
  border-radius: 4px;

  .ant-table-wrapper {
    width: calc(100% - 32px) !important;
  }
`;

export const LineBreaker = styled(Flex)`
  border-top: 1px solid ${theme.color.border};
  width: 100%;
`;

export const DeleteButton = styled(TableBody)`
  color: ${theme.color.error} !important;
  border: 1px solid ${theme.color.error};
  border-radius: 4px;
  padding: 4px 0;
  min-width: 92px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const colorCss = `
  color: ${theme.color.neutral3};
`;

export const BodyContainer = styled(Body)`
  ${colorCss}
`;
export const SubtextContainer = styled(Subtext)`
  ${colorCss}
  &.active {
    color: ${theme.color.neutral1};
  }
`;

export const ButtonContainer = styled(Button)`
  &:hover {
    background: ${theme.text.color.disabled};
  }
`;

export const AccessRoleRow = styled(Subtext)<{ selected: boolean }>`
  display: flex;
  align-items: center;
  padding: 6px 14px;
  background: ${({ selected }) => (selected ? theme.color.background2 : 'white')} !important;
  &:hover {
    background-color: ${theme.color.background2} !important;
  }
`;
